import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyBNFRlC381p1bmgtPE0Oc1BYtbInZCpLQs",
  authDomain: "parlament.firebaseapp.com",
  databaseURL: "https://parlament.firebaseio.com",
  projectId: "parlament",
  storageBucket: "parlament.appspot.com",
  messagingSenderId: "300879800692",
  appId: "1:300879800692:web:20e1418960e37ffc"
};
firebase.initializeApp(firebaseConfig);

export default firebase;
